import React from 'react';

function SelectActionButton(props) {
    return (
        <button className={`sm-show content-action-button mr2 ${props.isSelected && 'selected'}`} onMouseDown={props.toggleMoveMode}><img className="button-icon" height="18" width="18" src="/img/icons/bulk-action-toggle.svg" /></button>
    );
}

export default SelectActionButton;
